import React, { useState } from 'react';
import Box from '@mui/material/Box';
import CreateTransferOrdersForm from './CreateTransferOrdersForm';
import tplHelpers from '../../helpers/tpl';

function CreateTransferOrders(props) {

    const [warehouses, setWarehouses] = useState('');

    const warehouse_options = [
        { value: "Texas to Geodis", name: "Texas to Geodis"},
    ];

    const createTransferOrder = async () => {
        props.setLoading(true);
        try {
            const payload = {
                to_from_warehouse: warehouses ? warehouses : null,
            };
            
            const res = await tplHelpers.createTransferOrder(payload, props.company, props.token);

            if (res.status === 200) {
                if (res.data.message === "Success") {
                    props.toast.success("Successfully create transfer order.");
                } else {
                    props.toast.error(res.data.message);
                };  
            } else {
                props.toast.error("An error occurred while creating transfer order.")
            };
        } catch(err) {
            console.log('createTransferOrder', err);
            props.toast.error('Failed to create transfer order!');
        } finally {
            props.setLoading(false);
        };
    };

    return(
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>Create Transfer Orders</h1>
                <CreateTransferOrdersForm
                    isMobile = {props.isMobile}
                    warehouse_options = {warehouse_options}
                    warehouses = {warehouses}
                    setWarehouses = {setWarehouses}
                    createTransferOrder = {createTransferOrder}
                />
            </Box>
        </Box>
    );
};

export default CreateTransferOrders;